import { BetStatus } from "@utils";

export const quickFilterOptions = [
	BetStatus.OPEN,
	BetStatus.LIVE,
	BetStatus.CLOSED,
	BetStatus.ALL,
] as const;
